module.exports = __webpack_public_path__ + "img/building_home_house_real estate_icon100x100.18d8634d.png";